export default function FinalCTA() {
  return (
    <section className="relative w-full px-4 md:px-6 py-16 md:py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20flowing%20abstract%20gradient%20composition%20with%20warm%20coral%20peach%20cream%20and%20sand%20tones%2C%20gentle%20overlapping%20organic%20wave%20shapes%2C%20minimalist%20clean%20aesthetic%2C%20subtle%20luminous%20texture%2C%20serene%20airy%20atmosphere%2C%20modern%20European%20design%20sensibility%2C%20no%20text%20no%20people%2C%20editorial%20quality%20background%2C%20soft%20diffused%20lighting%2C%20harmonious%20balanced%20composition%20with%20delicate%20layered%20transparency&width=1600&height=700&seq=final-cta-v2-2026-x1&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/85 via-background-50/70 to-background-50/85"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 font-heading">
          Start Using ItaobuySpreadsheet Today
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-xl mx-auto leading-relaxed">
          Access curated product data and start making smarter shopping decisions instantly with the most advanced structured spreadsheet platform for product comparison.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            <i className="ri-rocket-line mr-2"></i>
            Enter ItaobuySpreadsheet Dashboard
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-foreground-950 text-background-50 rounded-md hover:bg-foreground-800 transition-all whitespace-nowrap"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}